'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('textAlign', 'align');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/text-align.js
// module id = 4497
// module chunks = 168707334958949